
/**
 * Generates a clean, SEO-friendly slug from a title
 * Removes special characters, converts spaces to hyphens, and handles edge cases
 */
export const generateSlug = (title: string): string => {
  if (!title || typeof title !== 'string') {
    return 'event';
  }

  // Convert to lowercase and handle the slug generation
  let slug = title
    .toLowerCase()
    // Remove all special characters except spaces and hyphens
    .replace(/[^a-zA-Z0-9\s\-]/g, '')
    // Replace one or more spaces with single hyphen
    .replace(/\s+/g, '-')
    // Replace multiple consecutive hyphens with single hyphen
    .replace(/-+/g, '-')
    // Remove leading and trailing hyphens
    .replace(/^-+|-+$/g, '');

  // Ensure slug is not empty
  if (!slug) {
    slug = 'event';
  }

  return slug;
};

/**
 * Validates if a slug is properly formatted
 */
export const isValidSlug = (slug: string): boolean => {
  if (!slug) return false;
  
  // Check if slug contains only lowercase letters, numbers, and hyphens
  // Must not start or end with hyphens, and no consecutive hyphens
  const slugPattern = /^[a-z0-9]+(-[a-z0-9]+)*$/;
  return slugPattern.test(slug);
};

/**
 * Cleans existing malformed slugs
 */
export const cleanExistingSlug = (slug: string): string => {
  if (!slug) return 'event';
  
  // Decode any URL encoding first
  const decoded = decodeURIComponent(slug);
  
  // Apply the same cleaning logic as generateSlug
  return generateSlug(decoded);
};
